import { Component, Input } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DynamicField } from '@cargos/sprintpay-models';

@Component({
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatTooltipModule,
        MatCheckboxModule,
    ],
    selector: 'app-dynamic-checkboxes',
    templateUrl: './dynamic-checkboxes.component.html',
    styleUrls: ['./dynamic-checkboxes.component.scss'],
})
export class DynamicCheckboxesComponent {
    public formName: FormGroup;
    public values: string[] = [];

    @Input() field: DynamicField = {};

    constructor(private formgroupDirective: FormGroupDirective) {
        this.formName = formgroupDirective.control;
    }

    selectOption(value: string, checked: boolean): void {
        if (checked) {
            const existDescription = !!this.values.find((description) => {
                return value === description;
            });
            if (!existDescription) {
                this.values.push(value);
            }
        } else {
            const index = this.values.indexOf(value);
            index > -1 ? this.values.splice(index, 1) : '';
        }
        this.formName.get(this.field?.name!)?.setValue(this.values.join(','));
    }

    isFieldRequired(field: DynamicField): boolean {
        if (!field || !Array.isArray(field.validations)) return false;
        return field.validations.some((validation) => {
            if (validation.name !== 'required') return false;
            if (typeof validation.value === 'string') return validation.value === 'true';
            if (typeof validation.value === 'boolean') return validation.value === true;
            return false;
        });
    }
}
